import React from 'react';

/**
 * SAP's Service Layer names what people call documents in SAP's own menus.
 *
 * The integration screens list the entity names SAP sends — InventoryGenExits,
 * PurchaseDeliveryNotes — which mean nothing to someone who posts an Issue for
 * Production or a Goods Receipt PO every day. Several of them also cover more than
 * one screen in SAP: an Issue for Production is posted as a Goods Issue, and a
 * Receipt from Production as a Goods Receipt, so the labels name both.
 */
export const SAP_OBJECT_NAMES = {
  Orders: 'Sales Order',
  Items: 'Item Master Data',
  ProductTrees: 'Bill of Materials',
  ProductionOrders: 'Production Order',
  InventoryGenExits: 'Goods Issue / Issue for Production',
  InventoryGenEntries: 'Goods Receipt / Receipt from Production',
  PurchaseDeliveryNotes: 'Goods Receipt PO (GRPO)',
  PurchaseInvoices: 'A/P Invoice',
  PurchaseReturns: 'Goods Return',
  PurchaseCreditNotes: 'A/P Credit Memo',
  PurchaseOrders: 'Purchase Order',
  DeliveryNotes: 'Delivery',
  Invoices: 'A/R Invoice',
  Returns: 'Return',
  CreditNotes: 'A/R Credit Memo',
  StockTransfers: 'Inventory Transfer',
  InventoryPostings: 'Inventory Posting',
};

export function sapObjectName(technical) {
  return SAP_OBJECT_NAMES[technical] || technical;
}

/** SAP's menu name first; the technical name underneath, for whoever is debugging. */
export function SapObjectLabel({ name }) {
  const known = Object.prototype.hasOwnProperty.call(SAP_OBJECT_NAMES, name);
  return (
    <div>
      <div className="font-medium text-gray-900">{sapObjectName(name)}</div>
      {known && <div className="text-2xs text-gray-400 font-mono">{name}</div>}
    </div>
  );
}
